<!-- manage-subscription-dialog.component.html -->
<h2 mat-dialog-title>Centro assistenza</h2>

<mat-dialog-content>
  <div *ngIf="isLoading" class="text-center mt-3">
    <mat-spinner diameter="30"></mat-spinner>
    <p class="mt-2">Aggiornamento in corso...</p>
  </div>

  <mat-divider></mat-divider>

  <p class="mt-3">Hai bisogno di noi? Contattaci:</p>

  <mat-form-field appearance="outline" class="w-100">
    <mat-label>La nostra mail</mat-label>
    <input 
      matInput 
      [value]="helpEmail" 
      readonly
      #linkInput>
    <button 
      mat-icon-button 
      matSuffix 
      (click)="copyToClipboard()"
      [attr.aria-label]="'Copia link'">
      <mat-icon>content_copy</mat-icon>
    </button>
  </mat-form-field>

  <mat-form-field appearance="outline" class="w-100">
    <mat-label>Il nostro numero verde</mat-label>
    <input 
      matInput 
      [value]="helpNumber" 
      readonly
      #linkInput>
    <button 
      mat-icon-button 
      matSuffix 
      (click)="copyNumberToClipboard()"
      [attr.aria-label]="'Copia numero'">
      <mat-icon>content_copy</mat-icon>
    </button>
  </mat-form-field>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close [disabled]="isLoading">Indietro</button>
  <!-- <button 
    mat-raised-button 
    color="primary" 
    (click)="confirm()"
    [disabled]="isLoading || subscriptionForm.invalid"
  >
    <mat-icon>check</mat-icon>
    Salva
  </button> -->
</mat-dialog-actions>
